import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Layout } from "../components/Layout";
import { About } from "../components/about";
import { useSEO } from "../hooks/useSEO";

export const AboutPage = ({ data }) => {
  useSEO({
    title: "About Transwave Shipping & Logistics LLC | Dubai UAE",
    description:
      "Learn about Transwave Shipping and Logistics LLC — a SHAMS-licensed freight forwarding company in Dubai, UAE. Our mission, vision, team and commitment to reliable logistics.",
    canonical: "https://www.tranwaveshipping.com/about",
  });

  return (
    <Layout contactData={data.Contact}>
      {/* Page Hero — left-aligned + bottom stats bar */}
      <div className="page-hero page-hero--about">
        <div className="container">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
          >
            <nav className="page-breadcrumb" aria-label="breadcrumb">
              <Link to="/">Home</Link> <span>/</span> <span>About</span>
            </nav>
            <h1>About Us</h1>
            <p>UAE-licensed freight forwarding &amp; logistics company based in Dubai</p>
          </motion.div>
        </div>
        <motion.div
          className="hero-stats-bar"
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.4 }}
        >
          <div className="container">
            <div className="hero-stats-inner">
              <div className="hero-stat">
                <span className="hero-stat-value">UAE</span>
                <span className="hero-stat-label">Licensed & Regulated</span>
              </div>
              <div className="hero-stat">
                <span className="hero-stat-value">3+</span>
                <span className="hero-stat-label">Years Experience</span>
              </div>
              <div className="hero-stat">
                <span className="hero-stat-value">24h</span>
                <span className="hero-stat-label">Quote Response</span>
              </div>
              <div className="hero-stat">
                <span className="hero-stat-value">100%</span>
                <span className="hero-stat-label">Compliance</span>
              </div>
            </div>
          </div>
        </motion.div>
      </div>

      <About data={data.About} />

      {/* CTA */}
      <div className="page-cta">
        <div className="container text-center">
          <h3>Ready to ship with us?</h3>
          <p>Contact our team for a free quote on any logistics requirement.</p>
          <Link to="/contact" className="btn btn-custom btn-lg">Get a Free Quote</Link>
        </div>
      </div>
    </Layout>
  );
};
